import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function decodeJwtPayload(token) {
  try {
    const payloadPart = String(token || "").split(".")[1] || "";
    const normalized = payloadPart.replace(/-/g, "+").replace(/_/g, "/");
    return JSON.parse(atob(normalized));
  } catch (error) {
    return {};
  }
}

function persistSupportSession(tokens) {
  const accessToken = String(tokens?.access_token || "");
  const idToken = String(tokens?.id_token || "");
  const refreshToken = String(tokens?.refresh_token || "");
  const expiresIn = Number(tokens?.expires_in || 1800);
  const expirationTime = Date.now() + expiresIn * 1000;

  const payload = decodeJwtPayload(idToken);
  const username = String(
    payload["cognito:username"] || payload.username || payload.email || "support",
  );
  const cognitoClientId = String(process.env.REACT_APP_COGNITO_CLIENT_ID || "");
  const prefix = cognitoClientId
    ? `CognitoIdentityServiceProvider.${cognitoClientId}`
    : "";

  localStorage.setItem("expiration_time", String(expirationTime));
  localStorage.setItem("jwt_token", accessToken);
  localStorage.setItem("idToken", idToken);
  localStorage.setItem("refreshToken", refreshToken);
  localStorage.setItem("auth:lastKnown", "1");

  if (!prefix) return;

  localStorage.setItem(`${prefix}.LastAuthUser`, username);
  localStorage.setItem(`${prefix}.${username}.accessToken`, accessToken);
  localStorage.setItem(`${prefix}.${username}.idToken`, idToken);
  localStorage.setItem(`${prefix}.${username}.refreshToken`, refreshToken);
  localStorage.setItem(`${prefix}.${username}.clockDrift`, "0");
}

export default function SupportAccessPage() {
  const navigate = useNavigate();
  const [message, setMessage] = useState("Preparando acesso assistido...");

  useEffect(() => {
    let active = true;

    async function exchangeSupportCode() {
      try {
        const query = new URLSearchParams(window.location.search);
        const code = String(query.get("code") || "").trim();

        if (!code) {
          throw new Error("Código de acesso ausente.");
        }

        const apiBase = String(
          query.get("api_base") ||
            query.get("apiBase") ||
            process.env.REACT_APP_SUPPORT_ACCESS_API_BASE_URL ||
            process.env.REACT_APP_SUPPORT_HUB_URL ||
            "https://123crm-hub.zp.123zap.com.br",
        )
          .trim()
          .replace(/\/+$/, "");

        const response = await fetch(
          `${apiBase}/api/public/support-access/exchange?code=${encodeURIComponent(code)}`,
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
          },
        );
        const data = await response.json().catch(() => ({}));

        if (!response.ok) {
          console.error("Falha ao trocar código de acesso assistido:", {
            status: response.status,
            detail: data?.detail,
          });
          throw new Error("Falha ao iniciar sessão assistida.");
        }

        persistSupportSession(data?.tokens || {});

        if (!active) return;

        setMessage("Sessão criada. Redirecionando...");
        window.location.replace("/painel");
      } catch (error) {
        if (!active) return;
        console.error("Erro no acesso assistido:", error);
        setMessage("Não foi possível iniciar a sessão assistida.");
        window.setTimeout(() => navigate("/login"), 1600);
      }
    }

    exchangeSupportCode();

    return () => {
      active = false;
    };
  }, [navigate]);

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "grid",
        placeItems: "center",
        padding: 24,
      }}
    >
      <div
        style={{
          maxWidth: 420,
          width: "100%",
          border: "1px solid #e2e8f0",
          borderRadius: 12,
          padding: 24,
          textAlign: "center",
        }}
      >
        <h2 style={{ marginTop: 0, marginBottom: 8 }}>Acesso assistido</h2>
        <p style={{ margin: 0, color: "#475569" }}>{message}</p>
      </div>
    </div>
  );
}
